import { InputNumber, InputNumberProps, Space } from 'antd';
import { FC, ReactNode } from 'react';

interface XmInputNumberUnitProps extends InputNumberProps {
  readonly unit: ReactNode;
}

/** InputNumber with a unit box — replaces deprecated addonAfter; className/style size the whole group. */
export const XmInputNumberUnit: FC<XmInputNumberUnitProps> = ({ unit, className, style, ...inputProps }) => (
  <Space.Compact className={className} style={style}>
    <InputNumber {...inputProps} style={{ flex: 1, minWidth: 0 }} />
    <Space.Addon disabled={inputProps.disabled}>{unit}</Space.Addon>
  </Space.Compact>
);
